import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";

import { Modal, Button, ErrorBanner, noop } from "@flashtalking/rhombus-react";

import { API_URL, ASSET_TYPES } from "utils/constants";
import { fetchAssetDetail } from "reducers/Assets";

import "./PreviewAssetsModal.css";

export default function PreviewAssetsModal(props) {
	const { onClose, assetType, name, id, libraryId, encoded } = props;
	const [isLoading, setIsLoading] = useState(assetType === ASSET_TYPES.IMAGE);
	const [assetDetails, setAssetDetails] = useState({});
	const [error, setError] = useState("");

	const dispatch = useDispatch();

	const base = `${API_URL}/crm/v1/`;
	let url = '';

	const bladeProps = {
		verticallyCenter: true,
	};

	useEffect(() => {
		//fetch asset details for encoded video url
		if(assetType === ASSET_TYPES.VIDEO && encoded) {
			dispatch(fetchAssetDetail(libraryId, assetType, id))
				.then((resp) => {
					if(resp.success && resp.payload?.data) {
						setAssetDetails(resp.payload.data);
					} else {
						let errorMsg = resp.payload?.errorObj?.description || "Error loading asset";
						setError(errorMsg);
					}
				});
		}
	}, []);

	function onError() {
		setIsLoading(false);
		setError("Asset failed to load");
	}

	function renderContent() {
		let content = null;
		let errorContent = null;

		if(error.length) {
			errorContent = <ErrorBanner title={error} />;
		}

		if (assetType === ASSET_TYPES.IMAGE) {
			url = `${base}creative-libraries/${libraryId}/images/show/${name}`;
			content = (
				<img
					src={url}
					alt={`Preview of ${name}`}
					onLoad={() => setIsLoading(false)}
					onError={onError}
					className="media"
				/>
			);
		} else if (assetType === ASSET_TYPES.VIDEO && !isLoading) {
			if (encoded) {
				url = `https://${assetDetails.url}`;
			} else {
				url = `${base}asset-manager/${libraryId}/videos/${name}`;
			}

			content = (
				<video className="media" src={url} controls />
			);
		} else if (assetType === ASSET_TYPES.RICHLOAD) {
			url = `${base}asset-manager/${libraryId}/richloads/${name}?download=false`;
			content = <iframe className="media" src={url} height="100%"  />;
		} else if (assetType === ASSET_TYPES.AUDIO) {
			url = `${base}ui/asset-manager/${libraryId}/audios/${name}`;
			content = <audio className="media" src={url} controls />;
		}
		return (
			<div className="modal-content">
				{errorContent ? errorContent : content}
			</div>
		);
	}

	function modalFooter() {
		return (
			<Button
				onClick={onClose}
				theme="default">
				Back
			</Button>
		);
	}

	return (
		<Modal
			title={assetType && name ? `Preview ${assetType} - ${name}` : "Preview Asset"}
			renderContent={renderContent}
			renderFooter={modalFooter}
			onClose={onClose}
			allowFullScreen={false}
			bladeProps={bladeProps}
			className="preview-assets-modal"
			type="modal" />
	);
}

PreviewAssetsModal.displayName = "PreviewAssetsModal";

PreviewAssetsModal.propTypes = {
	id: PropTypes.number,
	name: PropTypes.string,
	assetType: PropTypes.string,
	libraryId: PropTypes.string,
	onClose: PropTypes.func,
};

PreviewAssetsModal.defaultProps = {
	onClose: noop,
	id: 0,
	name: "",
	assetType: "",
	libraryId: "",
};
